<template>
  <a-select
      showSearch
      allowClear
      :value="value"
      :style="{width: width}"
      :mode="mode"
      :size="size"
      :placeholder="placeholder || defaultPlaceholder"
      :max-tag-count="maxTagCount"
      :disabled="disabled"
      :filter-option="false"
      @search="search"
      @change="changeValue"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small"/>
    <a-select-option v-if="mode==='default' && !loading" :value="''" :optionData="{}">{{placeholder || defaultPlaceholder}}</a-select-option>
    <a-select-option v-for="o in options" :value="o[valueFieldFinal]" :optionData="o" :key="o[keyFieldFinal]">{{o[labelFieldFinal]}}</a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'dol-select',
  props: {
    value: {default: ''},                 //value
    width: {type: String, default: 'auto'},
    keyField: {type: String, default: ''},        //key  修改了入参的名字以便使用 keyField不传的时候默认会使用valueField
    labelField: {type: String, default: ''},       //label
    valueField: {type: String, default: ''},          //value
    source: {type: String, default: 'dict'},              //数据源，dict | local | server
    //---------------------- if source === dict --------------------------------//
    dictCode: {type: String},                             //后台地址
    //---------------------- if source === server --------------------------------//
    url: {type: String},                                  //后台地址
    method: {type: String, default: 'get'},              //请求方式
    queryData: {
      type: Object, default: function () {
        return {};
      }
    },             //请求参数
    queryParams: {
      type: Object, default: function () {
        return {};
      }
    },             //请求参数
    queryPathData: {
      type: Object, default: function () {
        return {};
      }
    },             //请求参数
    serverType : {type: String, default: 'NodeJs'},       //server类型，NodeJs, DotNett
    dotNetTableType : {type: Number, default: 1},         //dotNet类型
    dotNetTableName : {},                                 //dotNet条件
    dotNetDefaultSortField : {type: String},              //默认排序字段
    dotNetFormatFlag : {type: Boolean, default: true},    //重新拼装dotNet请求结构
    dotNetReturnListField: {type: String, default: 'DATA_LIST'},
    dotNetQueryType: {type: String, default: '1001'},
    //---------------------- if source === local  --------------------------------//
    defaultData: {
      type: Array, default: function () {
        return [];
      }
    },                     //可选项数据
    placeholder: {type: String},
    mode: {type: String, default: 'default'},
    size: {type: String, default: 'default'},
    searchType: {type: String, default: 'local'},   //查询方式local前台，server后台
    searchField: {type: String, default: ''},   //后台查询的字段名
    maxTagCount: {type: Number},                //多选时最多的标签数量，多的会用省略号
    maxLength: {type: Number, default: 100},   //一次最大显示的备选项数量
    disabled: {},
    autoSelect: {type: Boolean, default: false},       //是否默认选中第一个值，暂时仅支持单选
    sql: ''
  },
  data: function () {
    this.search = this.$Dolphin.debounce(this.search, 500);
    return {
      initData: [],
      options: [],
      loading: false,
    };
  },
  watch: {
    queryData(value, prevValue){
      if(JSON.stringify(value) !== JSON.stringify(prevValue)){
        this.getOption();
      }
    },
    url() {
      this.getOption();
    },
    dictCode() {
      this.getOption();
    },
    value() {
      this.valueInit();
    },
    defaultData() {
      this.getOption()
    },
  },
  computed: {
    keyFieldFinal() {
      if (this.keyField) return this.keyField;
      return this.valueFieldFinal;
    },
    labelFieldFinal() {
      if (this.labelField) return this.labelField;
      return this.source === 'server' ? 'name' : 'text';
    },
    valueFieldFinal() {
      if (this.valueField) return this.valueField;
      return this.source === 'server' ? '_id' : 'code';
    },
    defaultPlaceholder(){
      return this.$t('dolPleaseSelect');
    },
  },
  methods: {
    changeValue(value) {
      this.$emit('input', value || '');
      let thisOption = this.options.find(o => o[this.valueFieldFinal] === value);
      if (this.mode === 'multiple') {
        if(value?.length > 0) {
          value = value.join(',')
        } else {
          value = ''
        }
      }
      this.$emit('change', value, thisOption);
    },
    //根据输入值去搜索，将initData处理成一定长度的option
    preOption(valueInput) {
      let options = [];
      if (valueInput) {
        let str = new RegExp(valueInput, 'i');
        this.initData.forEach(it => {
          if (str.test(it[this.labelFieldFinal])) {
            options.push(it)
          }
        });
      } else {
        options = this.initData.concat();
      }
      options = options.slice(0, this.maxLength);
      this.options = options;
      this.$set(this, 'options', options);
      this.valueInit();  //始终保证已选项在this.option内，避免显示id
    },
    //始终保证已选项在this.option内，避免显示id，根据是否多选区别操作
    valueInit() {
      if (!this.value) return;
      if (this.mode === 'multiple') {
        if (!this.value.length) return;
        this.value.forEach(val => {
          this.valuePush(val);
        })
      } else {
        this.valuePush(this.value)
      }
    },
    //根据value把对象push进option
    valuePush(value = '') {
      if (!value) return;
      let index = this.initData.findIndex(o => o[this.valueFieldFinal] === value);
      let index2 = this.options.findIndex(o => o[this.valueFieldFinal] === value);
      //若初始数组有该value，备选数组无该value，添加该value对应的对象
      if (index !== -1 && index2 === -1) this.options.push(this.initData[index]);
    },
    //获取initData
    getOption() {
      this.initData = [];
      return Promise.resolve().then(() => {
        if (this.source === 'local') {
          this.initData = this.defaultData;
          return true;
        } else if (this.source === 'dict') {
          return this.$dict(this.dictCode).then(data => {
            this.initData = data;
          });
        } else if (this.source === 'server') {
          let params = {
            url: this.url,
            method: this.method,
            params: this.queryParams,
            data: this.queryData,
            pathData: this.queryPathData,
          };
          this.loading = true;
          if(this.serverType === 'NodeJs'){
            return this.$ajax(params).then(({rows}) => {
              this.initData = rows;
            });
          }else {
            return this.loadDotNet();
          }
        }
      }).then(() => {
        this.preOption();
        this.autoSelectFirst();
      }).finally(() => {
        this.loading = false;
      })
    },
    loadDotNet(){
      let sendData = this.queryData;
      if(this.dotNetTableType === 3){ //复杂sql
        sendData = [ this.$dotNetUtil.commonReportJson(this.dotNetTableName, sendData, this.pageNumber, this.pageSize, this.dotNetDefaultSortField, this.dotNetTableType) ];
      }else if(this.dotNetTableType === 4){ // 组件外部处理格式
        sendData = this.queryData;
      }else{
        if(this.searchType === 'server'){ //分页查询
          sendData = [ this.$dotNetUtil.commonPageJson(this.dotNetTableName, sendData, this.pageNumber, this.pageSize, this.dotNetDefaultSortField, this.dotNetTableType) ];
        }else{ //普通查询，表名或sql
          sendData = [ this.$dotNetUtil.commonQueryJson(this.dotNetTableName, sendData, this.dotNetTableType) ];
        }
      }
      return this.$h5Api({
        type: this.dotNetQueryType,
        data: sendData,
        showMessage: false,
        loading: false,
      }).then(({data, total}) => {
        if(this.dotNetReturnListField){
          this.initData = data[this.dotNetReturnListField];
        }else{
          this.initData = data;
        }
      });
    },
    //自动选中第一个，仅对单选生效
    autoSelectFirst() {
      //其实this.value基本可以起到规避多选，因为[]为true，后面是为了更严谨
      if (!this.autoSelect || this.value || this.mode === 'multiple') return;
      return this.changeValue(this.options[0][this.valueFieldFinal]);
    },
    search(value) {
      if (this.searchType === 'local') return this.preOption(value);
      if (this.searchType === 'server') {
        //后台搜索，暂时只能根据请求方式决定请求内容，不想引入更多传参
        let conditionObj = this.method === 'get' ? 'queryParams' : 'queryData';
        //有searchField按searchField搜，没有按label_like搜
        let field = this.searchField || this.labelFieldFinal + '_like';
        this[conditionObj][field] = value;
        return this.getOption();
      }
    },
  },
  created() {
    this.getOption();
  }
}
</script>
